import { render } from "./BookingDone.vue?vue&type=template&id=74f39b87&scoped=true"
import script from "./BookingDone.vue?vue&type=script&lang=js"
export * from "./BookingDone.vue?vue&type=script&lang=js"

import "./BookingDone.vue?vue&type=style&index=0&id=74f39b87&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f39b87"],['__file',"src/views/Home/MakeAppointment/BookingDone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74f39b87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74f39b87', __exports__)) {
    console.log('reload')
    api.reload('74f39b87', __exports__)
  }
  
  module.hot.accept("./BookingDone.vue?vue&type=template&id=74f39b87&scoped=true", () => {
    console.log('re-render')
    api.rerender('74f39b87', render)
  })

}


export default __exports__